import CustomElement from '~utilities/custom-element';
const SR_ONLY_CLASS = 'u-sr-only';

class BypassNavigation extends CustomElement {
    constructor() {
        super();
    }

    template() {
        return `
            <section class="c-bypass-navigation u-sr-only" js-bypass>
                <a class="bypass-navigation__link" href="#content">
                    Direct naar de content
                </a>
            </section>
        `;
    }

    callback() {
        super.callback();

        const accessibilityLinks = [...this.element.querySelectorAll('a')];
        
        accessibilityLinks.forEach((link) => {
            link.addEventListener('focus', () => {
                this.element.classList.remove(SR_ONLY_CLASS);
            });
            link.addEventListener('blur', () => {
                this.element.classList.add(SR_ONLY_CLASS);
            });
        });
    }
}

export default BypassNavigation;